module.exports = __webpack_public_path__ + "img/commandeSection3.76943648.png";